import { CodeBlock, Copyable, ProblemNotice } from "@quovy/ui";
import type { ManagedAwsTrustBootstrapWire } from "@quovy/control-plane-contract";

export function ManagedAwsTrust({
  environmentSlug,
  trust,
}: {
  environmentSlug: string;
  trust: ManagedAwsTrustBootstrapWire;
}) {
  return (
    <div className="grid gap-4">
      <dl className="grid gap-3 text-sm sm:grid-cols-[9rem_minmax(0,1fr)]">
        <dt className="text-muted-foreground">Role name</dt>
        <dd className="min-w-0 font-mono text-xs">
          <Copyable value={trust.role_name}>{trust.role_name}</Copyable>
        </dd>
        <dt className="text-muted-foreground">Role ARN</dt>
        <dd className="min-w-0 font-mono text-xs">
          <Copyable value={trust.role_arn}>{trust.role_arn}</Copyable>
        </dd>
        <dt className="text-muted-foreground">External ID</dt>
        <dd className="min-w-0 font-mono text-xs">
          <Copyable value={trust.external_id}>{trust.external_id}</Copyable>
        </dd>
      </dl>

      <div className="grid gap-2">
        <span className="text-sm font-medium">Trust policy</span>
        <CodeBlock
          value={JSON.stringify(trust.assume_role_policy, null, 2)}
          language="json"
          maxHeightClass="max-h-72"
        />
      </div>

      <ProblemNotice
        tone="warning"
        title="The trust policy alone cannot provision infrastructure"
        howToResolve="Create this role in the AWS account for this environment, attach the Quovy provisioning permissions, then continue with the next step."
        resolution={{ kind: "in-place" }}
      >
        {environmentSlug} stays blocked until the role exists and a Quovy operator can validate it.
      </ProblemNotice>
    </div>
  );
}
